(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[219,464,167],{

/***/ 7280:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 1587:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(5680);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FV": function() { return /* binding */ fetchBusinessProfile; },
  "jB": function() { return /* binding */ useBusinessProfile; },
  "yL": function() { return /* binding */ useProvider; },
  "DF": function() { return /* binding */ useReviews; },
  "Su": function() { return /* binding */ useServices; }
});

// UNUSED EXPORTS: fetchAllServices, fetchProviders, fetchReviews

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(6200);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(5347);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var lib_axios = __webpack_require__(5960);
;// CONCATENATED MODULE: ./lib/axios.ts

const ENDPOINT_URL = "https://planet.yocale.com";
const axios_axios = lib_axios/* default.create */.Z.create({
    baseURL: "".concat(ENDPOINT_URL, "/api/v1")
});

// EXTERNAL MODULE: ./queries/index.query.ts + 1 modules
var index_query = __webpack_require__(5866);
;// CONCATENATED MODULE: ./hooks/useFetch.ts



const PAGINATE_LIMIT = Number("10");
const fetchReviews = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/reviews?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchServices = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/services?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchProviders = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    const _pageParam = pageParam !== null && pageParam || 0;
    const res = await axios_axios.get("/businesses/".concat(slug, "/providers?offset=").concat(_pageParam, "&limit=").concat(limit));
    return res.data.data;
};
const fetchAllServices = async function(slug) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        offset: 0,
        limit: 0,
        hasNext: true,
        items: []
    }, limit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 50;
    const offset = pageParam * limit;
    return axios.get("/businesses/".concat(slug, "/services?offset=").concat(offset, "&limit=").concat(limit)).then((res)=>{
        console.log("Fetch All Services, Offset: ".concat(offset, " - Limit: ").concat(limit));
        data.items.push(...res.data.data.items);
        data.offset = res.data.data.offset;
        data.limit = res.data.data.limit;
        data.hasNext = res.data.data.hasNext;
        if (!res.data.data.hasNext) return data;
        return fetchAllServices(slug, pageParam + 1, data);
    });
};
const fetchBusinessProfile = async function(slug) {
    let fields = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "services,providers,reviews,locations";
    const req = await axios_axios("/businesses/".concat(slug, "?fields=").concat(fields));
    return req.data;
};
const useBusinessProfile = ()=>{
    return (0,useQuery/* useQuery */.a)([
        index_query/* queries.publicProfile.businessKey */.o.publicProfile.businessKey
    ], {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false
    });
};
const useReviews = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "reviews"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchReviews(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return pages.length * PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};
const useServices = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "services"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchServices(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return pages.length * PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};
const useProvider = (slug)=>{
    return (0,useInfiniteQuery/* useInfiniteQuery */.N)([
        "providers"
    ], async (param)=>{
        let { pageParam =0  } = param;
        return fetchProviders(slug, pageParam, PAGINATE_LIMIT);
    }, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchIntervalInBackground: false,
        getNextPageParam: (lastPage, pages)=>{
            if (lastPage.hasNext) {
                return (pages.length - 1) * PAGINATE_LIMIT + PAGINATE_LIMIT;
            } else {
                return undefined;
            }
        }
    });
};



/***/ }),

/***/ 3890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useHowManyItems; },
/* harmony export */   "f": function() { return /* binding */ useCanRender; }
/* harmony export */ });
/* harmony import */ var _useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9350);
/* harmony import */ var types_business_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3345);


const useCanRender = (section)=>{
    const { data: businessProfile  } = (0,_useFetch__WEBPACK_IMPORTED_MODULE_0__/* .useBusinessProfile */ .jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget;
    const renderMethod = widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.settings[section].renderMethod;
    return renderMethod !== types_business_types__WEBPACK_IMPORTED_MODULE_1__/* .RenderMethod.NoRender */ .zT.NoRender;
};
const useHowManyItems = (section)=>{
    const { data: businessProfile  } = (0,_useFetch__WEBPACK_IMPORTED_MODULE_0__/* .useBusinessProfile */ .jB)();
    const sectionJSON = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data[section];
    const lengthOfItems = (sectionJSON === null || sectionJSON === void 0 ? void 0 : sectionJSON.items.length) || 0;
    return lengthOfItems;
};


/***/ }),

/***/ 5680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(4078);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(3906);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/I18nProvider.js
var I18nProvider = __webpack_require__(459);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7280);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./hooks/useRender.ts
var useRender = __webpack_require__(3890);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(6200);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./queries/index.query.ts + 1 modules
var index_query = __webpack_require__(5866);
;// CONCATENATED MODULE: ./hooks/useStickyNavbars.ts

function useStickyNavbars(headerRef, tabRef) {
    const $header = headerRef.current;
    const $tab = tabRef.current;
    (0,react.useEffect)(()=>{
        if ($tab && $header) {
            const headerHeight = $header.clientHeight;
            $tab.style.top = "".concat(headerHeight, "px");
        }
    }, [
        $header,
        $tab
    ]);
}
/* harmony default export */ var hooks_useStickyNavbars = (useStickyNavbars);

// EXTERNAL MODULE: ./locales/en/common.json
var en_common = __webpack_require__(464);
// EXTERNAL MODULE: ./locales/fr/common.json
var fr_common = __webpack_require__(5167);
;// CONCATENATED MODULE: ./pages/[slug].tsx














const Layout = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(574), __webpack_require__.e(527)]).then(__webpack_require__.bind(__webpack_require__, 5527)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5527)
            ]
    },
    ssr: true
});
const NavigationTab = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(574), __webpack_require__.e(591)]).then(__webpack_require__.bind(__webpack_require__, 1591)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1591)
            ]
    },
    ssr: true
});
const Cover = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(574), __webpack_require__.e(832), __webpack_require__.e(169), __webpack_require__.e(448)]).then(__webpack_require__.bind(__webpack_require__, 9448)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9448)
            ]
    },
    ssr: true
});
const AboutContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(574), __webpack_require__.e(259)]).then(__webpack_require__.bind(__webpack_require__, 7259)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7259)
            ]
    },
    ssr: true
});
const ProviderContainer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 531).then(__webpack_require__.bind(__webpack_require__, 7531)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7531)
            ]
    },
    ssr: true
});
const ServiceContainer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 821).then(__webpack_require__.bind(__webpack_require__, 4821)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4821)
            ]
    },
    ssr: true
});
const ReviewsContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(142)]).then(__webpack_require__.bind(__webpack_require__, 1885)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1885)
            ]
    },
    ssr: true
});
const Footer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(574), __webpack_require__.e(832), __webpack_require__.e(279)]).then(__webpack_require__.bind(__webpack_require__, 9279)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9279)
            ]
    },
    ssr: false,
    loading: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Loading..."
        })
});
function BusinessProfile(param) {
    let { slug  } = param;
    const { locale  } = (0,router.useRouter)();
    const { lang  } = (0,useTranslation/* default */.Z)();
    const { data: businessProfile  } = (0,useQuery/* useQuery */.a)([
        index_query/* queries.publicProfile.businessKey */.o.publicProfile.businessKey
    ], ()=>(0,useFetch/* fetchBusinessProfile */.FV)(slug), {
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const profile = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const headerRef = (0,react.useRef)();
    const tabRef = (0,react.useRef)();
    const onHeaderRefChange = (ref)=>{
        headerRef.current = ref;
    };
    hooks_useStickyNavbars(headerRef, tabRef);
    const [path, setPath] = (0,react.useState)("about");
    const isProviderRenderable = (0,useRender/* useCanRender */.f)("provider");
    const isReviewRenderable = (0,useRender/* useCanRender */.f)("review");
    const language = locale === "default" ? businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data.widget.settings.language.default : lang;
    const common = language === "fr" ? fr_common : en_common;
    (0,react.useEffect)(()=>{
        if (locale === "default") {
            document.documentElement.lang = language;
        }
    }, [
        language,
        locale
    ]);
    if (profile) {
        var _widget_settings_appearance, _profile_logo;
        const widget = profile === null || profile === void 0 ? void 0 : profile.widget;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(I18nProvider/* default */.Z, {
            lang: language,
            namespaces: {
                common
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                businessKey: profile.key,
                title: profile.name,
                description: profile.description,
                primaryColor: (_widget_settings_appearance = widget.settings.appearance) === null || _widget_settings_appearance === void 0 ? void 0 : _widget_settings_appearance.secondaryColor,
                logoURL: (_profile_logo = profile.logo) === null || _profile_logo === void 0 ? void 0 : _profile_logo.url,
                headerProps: {
                    onHeaderRefChange
                },
                languages: businessProfile.data.widget.settings.language.availables,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto max-w-screen-xl md:px-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cover, {
                            businessName: profile.name,
                            businessLogo: profile.logo,
                            rate: profile.rate,
                            covers: profile.coverImages
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: tabRef,
                            id: "tab",
                            className: "sticky top-16 pt-4 mb-8 bg-white/80 backdrop-blur-md z-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationTab, {
                                path: path,
                                setPath: setPath
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "px-4 md:px-0 pb-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: "about",
                                    className: classnames_default()("section", {
                                        hidden: path !== "about"
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutContainer, {
                                            profile: profile
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                                    ]
                                }),
                                isProviderRenderable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "providers",
                                    className: classnames_default()("section", {
                                        hidden: path !== "providers"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderContainer, {
                                        providersCount: profile.providers.items.length
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "services",
                                    className: classnames_default()("section", {
                                        hidden: path !== "services"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceContainer, {
                                        services: profile.services
                                    })
                                }),
                                isReviewRenderable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "reviews",
                                    className: classnames_default()("section", {
                                        hidden: path !== "reviews"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsContainer, {
                                        reviews: profile.reviews
                                    })
                                })
                            ]
                        }),
                         false && /*#__PURE__*/ 0
                    ]
                })
            })
        });
    }
}
var __N_SSG = true;
/* harmony default export */ var _slug_ = (BusinessProfile);


/***/ }),

/***/ 5866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ queries; }
});

// EXTERNAL MODULE: ./node_modules/@lukemorales/query-key-factory/dist/index.mjs
var dist = __webpack_require__(4967);
;// CONCATENATED MODULE: ./queries/businessProfile.query.ts

const businessProfileKeys = (0,dist/* createQueryKeys */.no)("publicProfile", {
    businessKey: null
});

;// CONCATENATED MODULE: ./queries/index.query.ts


const queries = (0,dist/* mergeQueryKeys */.kR)(businessProfileKeys);


/***/ }),

/***/ 3345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vn": function() { return /* binding */ AppointmentType; },
/* harmony export */   "zT": function() { return /* binding */ RenderMethod; }
/* harmony export */ });
/* unused harmony exports AvailableLanguages, ServiceUnavailable, ProviderUnavailable */
const Weekdays = (/* unused pure expression or super */ null && ([
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
]));
const Links = (/* unused pure expression or super */ null && ([
    "website",
    "facebook",
    "twitter",
    "instagram",
    "youtube"
]));
var AppointmentType;
(function(AppointmentType) {
    AppointmentType["InPerson"] = "in-person";
    AppointmentType["Virtual"] = "virtual";
})(AppointmentType || (AppointmentType = {}));
var RenderMethod;
(function(RenderMethod) {
    RenderMethod["Categorized"] = "categorized";
    RenderMethod["Plain"] = "plain";
    RenderMethod["NoRender"] = "no-render";
})(RenderMethod || (RenderMethod = {}));
var AvailableLanguages;
(function(AvailableLanguages) {
    AvailableLanguages["EN"] = "en";
    AvailableLanguages["FR"] = "fr";
})(AvailableLanguages || (AvailableLanguages = {}));
// export enum ServiceUnavailable {
// 	Price = "price",
// 	Duration = "duration",
// 	Description = "description ",
// }
const ServiceUnavailable = (/* unused pure expression or super */ null && ([
    "description",
    "price",
    "duration",
    "image"
]));
// export enum ProviderUnavailable {
// 	"rate",
// }
const ProviderUnavailable = (/* unused pure expression or super */ null && ([
    "rate",
    "image"
]));


/***/ }),

/***/ 464:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"navigation":{"about":"About","provider":"Provider","service":"Service","review":"Review","location":"Location"},"emptystate":{"providers":"No providers available","reviews":"No reviews available","services":"No services available"},"global":{"booknow":"Book Now","book":"Book","appointments":"Go to Appointments","showmore":"Show More","showless":"Show Less","socials":"Socials"},"workingHours":{"title":"Working Hours","weekdays":{"monday":"Monday","tuesday":"Tuesday","wednesday":"Wednesday","thursday":"Thursday","friday":"Friday","saturday":"Saturday","sunday":"Sunday"},"closed":"Closed"},"social":{"share_tweet":"Tweet","share_facebook":"Share on facebook","copy_clipboard":"Copy to clipboard","copy_clipboard_done":"Copied to clipboard","website":"Website"},"sections":{"about":{"description":"Online appointment scheduling for this business is available through Yocale. Choose your favorite provider or desired services to book online."},"services":{"accordion_label_one":"{{count}} Service","accordion_label_other":"{{count}} Services","others":"Others","virtual":"Virtual"},"reviews":{"overall":"{{count}} out of 5","customerRating_one":"{{count}} customer rating","customerRating_other":"{{count}} customers rating"}}}');

/***/ }),

/***/ 5167:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"navigation":{"about":"À propos de","provider":"Fournisseur","service":"Service","review":"Commentaire","location":"Emplacement"},"emptystate":{"providers":"Il n\'y a pour l\'instant aucun fournisseur.","reviews":"Il n\'y a pour l\'instant aucun commentaire client.","services":"Il n\'y a pour l\'instant aucun services."},"global":{"booknow":"Réserver","book":"Réserver","appointments":"Rendez-Vous","showmore":"Montrer plus","showless":"Montrer moins","socials":"Réseau sociales"},"workingHours":{"title":"Les heures disponible","weekdays":{"monday":"lundi","tuesday":"mardi","wednesday":"mercredi","thursday":"jeudi","friday":"vendredi","saturday":"samedi","sunday":"dimanche"},"closed":"Fermé"},"social":{"share_tweet":"Tweeter","share_facebook":"Partager sur Facebook","copy_clipboard":"Copié dans le presse-papier","copy_clipboard_done":"Copié dans le presse-papier","website":"Site Web"},"sections":{"about":{"description":"Online appointment scheduling for this business is available through Yocale. Choose your favorite provider or desired services to book online."},"services":{"accordion_label_one":"{{count}} Service","accordion_label_other":"{{count}} Services","others":"Autres","virtual":"Virtuelle"},"reviews":{"overall":"{{count}} sur 5","customerRating_one":"{{count}} évaluation des client","customerRating_other":"{{count}} évaluation des clients"}}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [564,774,888,179], function() { return __webpack_exec__(1587); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);